module.exports = __webpack_public_path__ + "img/loader.c8d74389.gif";